import http from "../httpService";

class VoucherService {
    GetAll(searchKey, skipCount, maxResultCount) {
        let result = http.get('/vouchers?&searchKey=' + searchKey + '&skipCount=' + skipCount + '&maxResultCount=' + maxResultCount);
        return result;
    }

    Create(name, voucherCode, isPercentage, value, isCanExpire, expiryDate, isForAllProduct, productType, isActive) {
        var discountValue = isPercentage ? parseFloat(value) / 100 : value
        let result = http.post('/vouchers',
            {
                name: name,
                voucherCode: voucherCode,
                isPercentage: isPercentage / 100,
                value: discountValue,
                isCanExpire: isCanExpire,
                expiryDate: expiryDate,
                isForAllProduct: isForAllProduct,
                productTypeId: productType,
                isActive: isActive
            });
        return result;
    }

    Update(id, name, voucherCode, isPercentage, value, isCanExpire, expiryDate, isForAllProduct, productType, isActive) {
        var discountValue = isPercentage ? parseFloat(value) / 100 : value
        let result = http.put('/vouchers',
            {
                id: id,
                name: name,
                voucherCode: voucherCode,
                isPercentage: isPercentage / 100,
                value: discountValue,
                isCanExpire: isCanExpire,
                expiryDate: expiryDate,
                isForAllProduct: isForAllProduct,
                productTypeId: productType,
                isActive: isActive
            });
        return result;
    }

    Get(id) {
        let result = http.get('/vouchers/' + id);
        return result;
    }
}

export default new VoucherService();